import script from "./BriefcaseActionButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./BriefcaseActionButtons.vue?vue&type=script&setup=true&lang=js"

import "./BriefcaseActionButtons.vue?vue&type=style&index=0&id=73ca9c04&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ca9c04"]])

export default __exports__